const rodzajUslugi = { t: 'Rodzaj usługi', name: 'rodzaj-serwisu', hint: { url: '/service_kind' }}
export default rodzajUslugi